import { jsx as _jsx } from 'react/jsx-runtime.js';
import { useState } from 'react';
import { useTranslation } from '@stepstone-platform/i18n';
import { Input } from '../../common/Input/index.js';
import { PasswordToggle } from '../../common/PasswordToggle/PasswordToggle.js';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks.js';
import { validatePassword } from '../../../helpers/validatePassword.js';
import { passwordSelector, updatePassword, updatePasswordError, updatePasswordErrorMessage, } from '../../../views/Login/loginSlice.js';
export const LoginPasswordInput = () => {
    const { t } = useTranslation();
    const passwordState = useAppSelector(passwordSelector);
    const dispatch = useAppDispatch();
    const [toggleIcon, setToggleIcon] = useState(false);
    const passwordInputType = () => (toggleIcon ? 'text' : 'password');
    const [isInteraction, setIsInteraction] = useState(false);
    const onBlurPassword = ({ target: { value }, }) => {
        if (!isInteraction) {
            return;
        }
        setIsInteraction(false);
        const hasError = !validatePassword(value);
        dispatch(updatePasswordError(hasError));
        if (hasError) {
            dispatch(updatePasswordErrorMessage(t('loginregistration.password.validation.error')));
        }
    };
    const passwordOnChange = ({ target: { value }, }) => {
        if (!value.length) {
            dispatch(updatePasswordError(false));
            setIsInteraction(false);
        }
        else {
            setIsInteraction(true);
            validatePassword(value) && dispatch(updatePasswordError(false));
        }
        dispatch(updatePassword(value));
    };
    const { value, error, errorMessage } = passwordState;
    return (_jsx(Input, { dataTestId: "password-input", value: value, onChange: passwordOnChange, type: passwordInputType(), name: 'password', formLabel: t('loginregistration.login.password.headerInput'), placeholder: t('loginregistration.login.password.placeholder'), suffix: _jsx(PasswordToggle, { toggle: toggleIcon, onClick: () => setToggleIcon(!toggleIcon) }), hasError: error, errorText: errorMessage, onBlur: onBlurPassword, autoComplete: 'current-password' }));
};
//# sourceMappingURL=LoginPasswordInput.js.map